import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { DialogTitle } from './'
import { getBlueprintDetails } from '../../../store/global/selectors';
import Config from "../../../config/";
import CircularProgress from '@material-ui/core/CircularProgress';

export default function ClusterletDashboard({ ClusterletDashboardDialog, clusterlet, viewId }) {

    const [loading, setLoading] = useState(true);
    const blueprintId = useSelector(getBlueprintDetails).docid;
    const [url, setUrl] = useState(null);

    useEffect(() => {
        if(clusterlet) setUrl(`${Config.apiUrl}/preview/dashboard/clusterlet?uuid=${clusterlet.id}&blueprintId=${blueprintId}`)
        else setUrl(`${Config.apiUrl}/preview/dashboard/view?blueprintId=${blueprintId}&viewId=${viewId}`)

    },[])

    const onClose = () =>{
        ClusterletDashboardDialog(false);
    }

    const hideSpinner = () => {
        setLoading(false);
    }


    return (
        <Dialog
            open={true}
            aria-labelledby="customized-dialog-title"
            PaperProps={{ style: { width: 1800, height: "100%", maxWidth: 1800 } }}
        >
            <DialogTitle id="customized-dialog-title" onClose={onClose}  >
                Dashboard
            </DialogTitle>
            
            <DialogContent style={{ overflow: "hidden" }} dividers>

            {loading === true && <Grid container alignItems='center' justify='center' style={{ minHeight: "70vh" }}>
                <CircularProgress />         
            </Grid>}

            <iframe src={url} width={"100%"} height={"100%"} frameBorder={"0"}  onLoad={hideSpinner} />


            </DialogContent>

        </Dialog>

    )
}